/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Tr_6_AInputs */

const en_mk_tut_tr_6_a = /** @type {(inputs: Mk_Tut_Tr_6_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Analytics to see which agent works the most, then set a spending cap on it. A daily routine is the usual culprit — check whether it really needs to run every day.`)
};

const id_mk_tut_tr_6_a = /** @type {(inputs: Mk_Tut_Tr_6_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka menu Analytics untuk melihat agen mana yang paling banyak bekerja, lalu pasang batas belanja pada agen itu. Rutinitas harian adalah penyebab paling umum — periksa apakah jadwalnya memang perlu setiap hari.`)
};

/**
* | output |
* | --- |
* | "Open Analytics to see which agent works the most, then set a spending cap on it. A daily routine is the usual culprit — check whether it really needs to run ..." |
*
* @param {Mk_Tut_Tr_6_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_tr_6_a = /** @type {((inputs?: Mk_Tut_Tr_6_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Tr_6_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_tr_6_a(inputs)
	return en_mk_tut_tr_6_a(inputs)
});